import axios from 'axios';
import { getAccessToken, setManagedToken } from '../lib/authSession';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
});

// Add token to all requests if available
api.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token might be expired
      localStorage.removeItem('notary_token');
      setManagedToken(null);
      // Optionally redirect to login
    }
    return Promise.reject(error);
  }
);

export default api;
